export type WrestlingBreakBetweenRoundsValue = "00:30" | "01:00";

export const DEFAULT_WRESTLING_BREAK_BETWEEN_ROUNDS: WrestlingBreakBetweenRoundsValue = "00:30";

export const WRESTLING_BREAK_BETWEEN_ROUNDS_OPTIONS: Array<{
    value: WrestlingBreakBetweenRoundsValue;
    labelTranslationKey: string;
}> = [
    {
        value: "00:30",
        labelTranslationKey: "discipline_packages.mma_break_between_rounds_30_sec",
    },
    {
        value: "01:00",
        labelTranslationKey: "discipline_packages.mma_break_between_rounds_1_minute",
    },
];

const PREDEFINED_VALUES = new Set<string>(WRESTLING_BREAK_BETWEEN_ROUNDS_OPTIONS.map(o => o.value));

export function normalizeWrestlingBreakSelection(value: string | null | undefined): WrestlingBreakBetweenRoundsValue {
    if (value && PREDEFINED_VALUES.has(value)) {
        return value as WrestlingBreakBetweenRoundsValue;
    }

    return DEFAULT_WRESTLING_BREAK_BETWEEN_ROUNDS;
}

export function getWrestlingBreakForRoundsChange(
    numberOfRounds: number | null,
    currentBreak: string | null | undefined,
): WrestlingBreakBetweenRoundsValue {
    const normalized = normalizeWrestlingBreakSelection(currentBreak);

    return normalized;
}
